package org.example.zone360.pages.coachDetails.sessionAllDetails.toneAnalysis

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.components.CustomSpacer
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSessionsData
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.Constants
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun ToneAnalysisBox(
    sessionData: GetSessionsData,
    sitePalette: SitePalette,
    breakpoint: Breakpoint){
    val toneAnalysisList = sessionData.sementics.tones
    Box(
        modifier = Modifier.fillMaxWidth()
            .height(170.px)
            .margin(top = 15.px)
            .borderRadius(12.px)
            .border(
                1.px,
                style = LineStyle.Solid,
                color = sitePalette.coachDetailsBoxBorder.rgb
            )
            .padding(16.px)
            .boxShadow(
                offsetY = 1.px,
                blurRadius = 3.px,
                color = sitePalette.textFieldTextColor.rgb.copyf(alpha = 0.1f)

            )
    ) {
        Column(modifier = Modifier.fillMaxSize()) {
            SectionTitle("Tone")
            Column(
                modifier = Modifier.gap(8.px)
                    .width(100.percent)
                    .margin(bottom = 10.px)
            ) {
                val topTones = toneAnalysisList
                    .sortedByDescending {  it.percentage ?: 0 }
                    .take(3)
                val highestTonePercentage = topTones.maxByOrNull { it.percentage ?: 0 }?.percentage
                val baseColor = Palette.NeutralColor.rgbLight

                topTones.forEachIndexed { index, tone ->
                    val isTop = tone.percentage == highestTonePercentage
                    val alpha = when (index) {
                        0 -> 1.0f
                        1 -> 0.73f
                        2 -> 0.56f
                        else -> 0.4f
                    }
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        FieldTitleTextNormalSimple(
                            text = "${tone.emoji ?: ""}  ${tone.label ?: "".replaceFirstChar {
                                if (it.isLowerCase()) it.titlecase() else it.toString()
                            }}",
                            width = 140.px,
                            fontSize = 14.px,
                            fontFamily = Constants.IBM_FONT
                        )
                        CustomSpacer(10.px)

                        val percentage = tone.percentage ?: 0
                        val barWidth = (percentage * 2.38).px

                        Box(
                            modifier = Modifier
                                .width(barWidth)
                                .height(16.px)
                                .borderRadius(
                                    bottomRight = if (isTop) 0.px else 2.92.px,
                                    topRight = if (isTop) 2.92.px else 0.px,
                                    topLeft = if (isTop) 2.92.px else 0.px
                                )
                                .backgroundColor(baseColor.copyf(alpha = alpha))
                        )

                        FieldTitleTextNormalSimple(
                            text = "${tone.percentage ?: 0}%",
                            fontSize = 12.px,
                            fontFamily = Constants.IBM_FONT,
                            marginLeft = 5.px
                        )
                    }
                }
            }
        }
    }
}
